import { all } from 'redux-saga/effects';

import authSagas from './auth/saga';
import signupCreateSagas from './signupCreate/saga';
import panelsettingsListSagas from './panelsettingsList/saga';
import newsFeedSagas from './newsFeed/saga';
import contactDetailsSagas from './contactDetails/saga';
import processDetailsSagas from './processDetails/saga';
import activityDetailsSagas from './activityDetails/saga';
import collectionDetailsSagas from './collectionDetails/saga';
import collectionItemDetailsSagas from './collectionItemDetails/saga';
import tenantDetailsSagas from './tenantDetails/saga';
import vocabularyDetailsSagas from './vocabularyDetails/saga';
import termDetailsSagas from './termDetails/saga';
import recordListingSagas from './recordListing/saga';
import newRecordSagas from './newRecord/saga';
import newSettingRecordSagas from './newSettingRecord/saga';
import newCollectionSagas from './newCollection/saga'
import newCollectionItemSagas from './newCollectionItem/saga';
import newParticipantSagas from './newParticipant/saga';
import newVocabularyRecordSagas from './newVocabularyRecord/saga';
import newCatalogItemRecordSagas from './newCatalogItemRecord/saga';
import newAccountItemRecordSagas from './newAccountItemRecord/saga';
import newPaymentMethodRecordSagas from './newPaymentMethodRecord/saga';
import newOrderRecordSagas from './newOrderRecord/saga';
import newContactBlockRecordSagas from './newContactBlockRecord/saga';
import newPaymentItemRecordSagas from './newPaymentItemRecord/saga';
import invoiceDetails from './invoiceDetails/saga';
import paymentDetailsSagas from './paymentDetails/saga';
import orderDetailsSagas from './orderDetails/saga';

import newProcessRecordSagas from './newProcessRecord/saga';
import newTermRecordSagas from './newTermRecord/saga';
import newTaskRecordSagas from './newTaskRecord/saga';
import menuItemsListSagas from './menuItemsList/saga';
import editTenantSagas from './editRecord/editTenant/saga';
import nodeEdgeDetailsSagas from './nodeEdgeDetails/saga'
import pageLoaderSagas from './pageLoader/saga'
import webBuilderSagas from './webBuilder/saga'
import postSagas from './postFeed/saga'

import catalogListingSagas from './catalog/saga';
import termListingSagas from './term/saga';
import fieldDetailsSagas from './fieldDetails/saga';
import lineItemsListingSagas from './lineItems/saga';
import addressListingSagas from './address/saga';
import contactBlockListingSagas from './contactBlock/saga';
import paymentMethodSelectSagas from './paymentProfileSelect/saga';

// eslint-disable-next-line
export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    contactDetailsSagas(),
    processDetailsSagas(),
    signupCreateSagas(),
    panelsettingsListSagas(),
    newsFeedSagas(),
    recordListingSagas(),
    newRecordSagas(),
    newSettingRecordSagas(),
    newTaskRecordSagas(),
    menuItemsListSagas(),
    activityDetailsSagas(),
    collectionDetailsSagas(),
    collectionItemDetailsSagas(),
    tenantDetailsSagas(),
    vocabularyDetailsSagas(),
    termDetailsSagas(),
    newVocabularyRecordSagas(),
    newTermRecordSagas(),
    newCollectionSagas(),
    newCollectionItemSagas(),
    newParticipantSagas(),
    newProcessRecordSagas(),
    editTenantSagas(),
    nodeEdgeDetailsSagas(),
    pageLoaderSagas(),
    newCatalogItemRecordSagas(),
    newAccountItemRecordSagas(),
    newPaymentMethodRecordSagas(),
    newOrderRecordSagas(),
    newContactBlockRecordSagas(),
    newPaymentItemRecordSagas(),
    invoiceDetails(),
    webBuilderSagas(),
    postSagas(),
    catalogListingSagas(),
    termListingSagas(),
    fieldDetailsSagas(),
    lineItemsListingSagas(),
    addressListingSagas(),
    contactBlockListingSagas(),
    paymentMethodSelectSagas(),
    paymentDetailsSagas(),
    orderDetailsSagas()
  ]);
}
